module.exports = __webpack_public_path__ + "static/media/populations-bar.1f154642.svg";